
	import Vue from "vue";
	import axios from "axios";
	import helpers from "../inc/helpers";
	import api from "../api";

	import LevyRow from "../components/LevyRow.vue";

	import TaxLevyYear from "../data/TaxLevyYear";
	import TaxEstimate from "../data/TaxEstimate";
	import TaxLevy from "../data/TaxLevy";
	import TaxRate from "../data/TaxRate";
	import TaxLookup from "../data/TaxLookup";
	import ParcelLookup from "../data/ParcelLookup";

	export default Vue.extend({
		props: ["marketValue", "taxDistrict"],

		data() {
			return {
				isLoading: true,
				taxEstimate: null as null | TaxEstimate,
				levyHistory: [] as Array<TaxLevyYear>,
			};
		},

		mounted() {
			this.setTaxEstimates(this.marketValue, this.taxDistrict);
		},

		methods: {
			setTaxEstimates(marketValue: number, taxDistrict: TaxRate) {
				this.isLoading = true;

				Promise.all([this.getLevyHistory(taxDistrict), this.getTaxEstimates(marketValue, taxDistrict)])
					.then(() => {
						this.isLoading = false;
					})
					.catch(() => {
						console.log("catch");
					});
			},

			getLevyHistory(taxDistrict: TaxRate): Promise<boolean> {
				return new Promise((resolve, reject) => {
					if (!taxDistrict) {
						this.levyHistory = [];
						resolve(true);
					} else {
						let endpoint = "https://datastore.geaugaconnected.com/wp-json/ds/v1/a5df4aa48668e4d96bb7761e0cb58d11/o/tax-facts-new-lookup/" + taxDistrict.gca_tax_rate_district_number;

						axios.get(endpoint).then((resp) => {
							if (resp.status === 200 && !!resp.data.data) {
								let data = resp.data.data;

								this.levyHistory = [];

								for (const property in data) {
									let newTaxLevyYear = {} as TaxLevyYear;

									newTaxLevyYear.date = property;
									newTaxLevyYear.levys = [] as Array<TaxLevy>;

									data[property].forEach((levy: TaxLevy) => {
										newTaxLevyYear.levys.push(levy);
									});

									this.levyHistory.push(newTaxLevyYear);
								}

								resolve(true);
							} else {
								resolve(false);
							}
						});
					}
				});
			},

			getTaxEstimates(marketValue: number, taxDistrict: TaxRate): Promise<boolean> {
				return new Promise((resolve, reject) => {
					if (!marketValue || !taxDistrict) {
						this.taxEstimate = null;
					} else {
						this.taxEstimate = new TaxEstimate(marketValue, "Residential", taxDistrict);
					}

					resolve(true);
				});
			},
		},

		computed: {
			latestLevyYear(): null | TaxLevyYear {
				return this.levyHistory.length ? this.levyHistory[0] : null;
			},

			sortedLevies(): Array<TaxLevy> {
				//return this.latestLevyYear.levys.sort((a, b) => a.NewM - b.NewM);
				return !!this.latestLevyYear ? this.latestLevyYear.levys : [];
			},

			isSearching(): boolean {
				return !!this.taxDistrict && !!this.marketValue;
			},
		},

		filters: {
			formatCurrency(val: string): string {
				return helpers.formatCurrency(val);
			},

			formatTaxDistrictNumber(number: number): string {
				return number.toString();
			},
		},

		watch: {
			taxDistrict() {
				this.setTaxEstimates(parseFloat(this.marketValue), this.taxDistrict);
			},

			marketValue() {
				this.setTaxEstimates(parseFloat(this.marketValue), this.taxDistrict);
			},
		},

		components: {
			LevyRow,
		},
	});
